import clsx from "clsx";
import { DetailedHTMLProps, Fragment, ImgHTMLAttributes } from "react";
import ReactMarkdown from "react-markdown";
import { SpecialComponents } from "react-markdown/lib/ast-to-react";
import { NormalComponents } from "react-markdown/lib/complex-types";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { IWithClassName } from "../../theme/default.theme";
import { withStyledMarkdown } from "../../theme/with-styled-markdown";

const { REACT_APP_STRAPI_URL = "" } = process.env;

interface IOwnProps {
    markdown?: string;
    components?: Partial<
        Omit<NormalComponents, keyof SpecialComponents> & SpecialComponents
    >;
}

const MarkdownComponents = {
    img: (
        image: DetailedHTMLProps<
            ImgHTMLAttributes<HTMLImageElement>,
            HTMLImageElement
        >,
    ) =>
        image.src ? (
            <img
                alt={image.alt}
                src={
                    (/(http(s?)):\/\//i.test(image.src ?? "")
                        ? ""
                        : REACT_APP_STRAPI_URL) + image.src
                }
                className={image.className}
                width={image.width as number | undefined}
                height={image.height as number | undefined}
            />
        ) : (
            <Fragment />
        ),
};

export const DynamicMarkdownContent = withStyledMarkdown(
    ({ markdown, className, components }: IOwnProps & IWithClassName) =>
        markdown ? (
            <ReactMarkdown
                rehypePlugins={[rehypeRaw, remarkGfm]}
                components={
                    components
                        ? { ...MarkdownComponents, ...components }
                        : MarkdownComponents
                }
                className={clsx(className, "markdown-content")}
            >
                {markdown}
            </ReactMarkdown>
        ) : (
            <></>
        ),
);
